import { LutienApi } from '@src/services/lutien/lutien-api';

const client = new LutienApi();

export const getOrganizationsNames = async (): Promise<Record<string, string>> => {
  try {
    const organizations = await client.v1.organizations.get();

    const orgMap: Record<string, string> = {};
    organizations.forEach((org) => {
      orgMap[org.id] = org.fantasyName || org.corporateName || org.id;
    });

    return orgMap;
  } catch (error) {
    console.error('Error fetching organizations:', error);
    return {};
  }
};
